import { createAsyncThunk } from '@reduxjs/toolkit';

import { getScopesList as getScopesListApi } from '../../../helpers/auth/backend_helper';

export const getScopesList = createAsyncThunk(
	'foods/getScopesList',
	async () => {
		try {
			const response = getScopesListApi();
			return response;
		} catch (error) {
			throw new Error(error);
		}
	}
);
